// Load the bundled models once, only when a video call needs them.
let detectorPromise;

export function loadFaceDetector(reload = false) {
  if (reload) detectorPromise = null;
  if (!detectorPromise) {
    const attempt = (async () => {
      const faceapi = await import('face-api.js');
      const modelPath = `${process.env.PUBLIC_URL || ''}/models`;
      await Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(modelPath),
        faceapi.nets.faceLandmark68Net.loadFromUri(modelPath),
      ]);
      const options = new faceapi.TinyFaceDetectorOptions({ inputSize: 224, scoreThreshold: 0.4 });
      return input => faceapi.detectAllFaces(input, options).withFaceLandmarks();
    })().catch(error => {
      if (detectorPromise === attempt) detectorPromise = null;
      throw error;
    });
    detectorPromise = attempt;
  }
  return detectorPromise;
}
